@if (config) {
  <span class="env-badge" [ngClass]="config.cssClass">
    <span class="label">{{ config.label }}</span>
  </span>
}
